
import PageRouter from "./PageRouter/PageRouter";

function App() {
  return (
    <>
    <PageRouter/>
    </>
  );
}

export default App;
